import React from "react";
import { AdBannerFooterContainerProps } from "./types";
import { Container } from "./styles";
import { GoogleBannerAd } from "../GoogleAds/GoogleBannerAd";

/**
 * Componente AdBannerFooterContainerMobile
 *
 * Contêiner para exibir um banner de anúncio centralizado.
 *
 * @param adUnit - Unidade de anúncio do GPT.
 * @param width - Largura do banner.
 * @param height - Altura do banner.
 * @param marginBottom - Margem inferior opcional.
 */
export const AdBannerContainer: React.FC<AdBannerFooterContainerProps> = ({
  slotId,
  adUnit,
  sizes,
  marginBottom = 0,
  marginTop = 0,
}) => {
  return (
    <Container style={{ marginBottom, marginTop }}>
      <GoogleBannerAd slotId={slotId} adUnitPath={adUnit} sizes={sizes} />
    </Container>
  );
};
